// @flow
import Alt from 'alt/src/index';

interface StoreReduce {
    action:any;
    data: any;
}

export interface AltStore<S> {
    getState():S;
    listen(handler:(state:S) => any):() => void;
    unlisten(handler:(state:S) => any):void;
    emitChange():void;
}

export interface Action<T> {
    ( args:T):void;
    defer(data:any):void;
}

export interface SourceModel<S> {
    local(state:any):any;
    remote(state:any):Promise<S>;
    shouldFetch(fetchFn:(...args:Array<any>) => boolean):void;
    loading?:(args:any) => void;
    success?:(state:S) => void;
    error?:(args:any) => void;
    interceptResponse(response:any, action:Action<any>, ...args:Array<any>):any;
}

export type Source = {[name:string]: () => SourceModel<any>};

export type Actions = {[action:string]:Action<any>};

export interface ActionsClass {
    generateActions( ...action:Array<string>):void;
    actions?:Actions;
}

type ActionHandler = ( ...data:Array<any>) => any;

/*
export enum lifeCycleEvents {
    Bootstrap,
    Snapshot,
    Init,
    Rollback,
    Error
}
*/

export interface StoreModel<S> {
    //Actions
    bindAction( action:Action<any>, handler:ActionHandler):void;
    bindActions(actions:ActionsClass):void;

    //Methods/Listeners
    exportPublicMethods(exportConfig:any):void;
    bindListeners(config:{[methodName:string]:Action<any> | Actions}):void;
    exportAsync(source:Source):void;
    registerAsync(datasource:Source):void;

    //state
    setState(state:S):void;
    setState(stateFn:(currentState:S, nextState:S) => S):void;
    getState():S;
    waitFor(store:AltStore<any>):void;

    //events
    onSerialize(fn:(data:any) => any):void;
    onDeserialize(fn:(data:any) => any):void;
    on(event:string, callback:() => any):void;
    emitChange():void;
    waitFor(storeOrStores:AltStore<any> | Array<AltStore<any>>):void;
    otherwise(data:any, action:Action<any>):void;
    observe(alt:Alt):any;
    reduce(state:any, config:StoreReduce):Object;
    preventDefault():void;
    afterEach(payload:Object, state:Object):void;
    beforeEach(payload:Object, state:Object):void;
    // TODO: Embed dispatcher interface in def
    dispatcher?:any;

    //instance
    getInstance():AltStore<S>;
    alt?:Alt;
    displayName?:string;
}

let alt = new Alt();
export default alt;
